module.exports = __webpack_public_path__ + "static/media/payrolluser.e60d67a5.svg";